import { useState } from "react";

export type ActiveType = "add" | "delete" | "sort";

export const useBottomMenu = () => {
    const [isOpen, setIsOpen] = useState(false);
    const open = () => setIsOpen(true);
    const close = () => setIsOpen(false);

    return { isOpen, open, close };
};
